module.exports = __webpack_public_path__ + "img/elecciones2021.b7010e62.jpg";